import axios, { AxiosResponse } from 'axios';
import { APIResponse } from '../Helper/type';
import IOrgUser from './OrgUser.interface';
import { handleApiResponse } from '../Helper/apiResponseHandler';
import apiCallWrapper from '../../apiwrapper/apiCallWrapper';
import IUserList from '../UserList/UserList.interface';
import IOrganizationUser from '../OrganizationUser/OrganizationUser.interface';
import { adminUserList } from '../OrganizationUser/OrganizationUser.helper';
import { clearSession } from '../Helper/helper';
import { store } from '../../store/store';
import { invalidateSession } from '../../store/slice/sessionSlice';
import { decrypt } from '../Helper/encryption';

// Declaring the web server path
const backEndServerUrl = String(process.env.REACT_APP_BACK_END_SERVER_URL ?? '');
export default class OrgUser {
  public apiResponse: APIResponse | undefined;
  public encryptedToken = sessionStorage.getItem('jwtToken');
  public jwtToken = decrypt(this.encryptedToken);
  public apiKey = String(process.env.REACT_APP_API_KEY ?? '');
  public config = {
    headers: {
      Authorization: this.jwtToken,
      'x-api-key': this.apiKey
    }
  };

  // Declaring the constructor to get the request body. This constructor is of type IOrgUser
  constructor(public userInfo: IOrgUser) {}

  // Declaring the sub-path
  public subPath: string = '/organization/user';

  // POST request for creating Organization Users and storing it to db. This methods returns a response body along with a status code.
  public async createUser(): Promise<APIResponse> {
    try {
      // calling wrapper function to wrap the header.
      const axiosWithRoles = apiCallWrapper(this.subPath, 'POST');
      const url: string = this.createUrl(this.subPath);
      const requestBody: any = this.userInfo;
      const response: AxiosResponse<any, any> = await axiosWithRoles.post(url, requestBody);
      const errorMessage = '';
      const successMessage = '';
      this.apiResponse = handleApiResponse(response.status, errorMessage, successMessage);
    } catch (error: any) {
      switch (error?.response?.status) {
        case 406:
          this.apiResponse = {
            statusCode: 406,
            body: 'User already exists in the Database'
          };
          break;
        default:
          this.apiResponse = { statusCode: 500, body: JSON.stringify(error) };
      }
    }
    return this.apiResponse;
  }

  public async getUserDetails(): Promise<APIResponse> {
    const email = this.userInfo.email;
    const userDetailsPath = this.subPath + '/' + email;
    try {
      // calling wrapper function to wrap the header.
      const axiosWithRoles = apiCallWrapper(userDetailsPath, 'GET');
      const url: string = this.createUrl(userDetailsPath);
      const response: AxiosResponse<any, any> = await axiosWithRoles.get(url);
      if (!response.data.email && !response.data.orgName) {
        store.dispatch(invalidateSession());
      }
      const extractedFname = response.data.name;
      sessionStorage.setItem('userName', extractedFname);
      this.apiResponse = { statusCode: response.status, body: response?.data };
    } catch (error: any) {
      if (error.code === 'ERR_NETWORK') {
        store.dispatch(invalidateSession());
        this.apiResponse = { statusCode: 403, body: null, error: JSON.stringify(error) };
      }
      switch (error?.response?.status) {
        case 406:
          this.apiResponse = {
            statusCode: 406,
            body: null,
            error: 'No data found'
          };
          break;
        default:
          this.apiResponse = { statusCode: 500, body: null, error: JSON.stringify(error) };
      }
    }
    return this.apiResponse;
  }

  public async getAllUser(): Promise<Array<IUserList>> {
    const userDetailsPath = this.subPath;
    try {
      // calling wrapper function to wrap the header.
      const axiosWithRoles = apiCallWrapper(userDetailsPath, 'GET');
      const url: string = this.createUrl(userDetailsPath);
      const response: AxiosResponse<any, any> = await axios.get(url, this.config);
      const arrUsers: Array<IOrganizationUser> = [];
      if (Array.isArray(response.data)) {
        response.data.forEach((element: IOrganizationUser) => {
          arrUsers.push(element);
        });
      }
      return adminUserList(arrUsers);
      // this.apiResponse = handleApiResponse(response.status, errorMessage, successMessage);
    } catch (error: any) {
      console.error(error);
      if (error.code === 'ERR_NETWORK') {
        store.dispatch(invalidateSession());
        return [];
      }
    }
    return await this.getAllUser();
  }
  // Binding the Webserver path and sub-path

  private createUrl(params?: string): string {
    return backEndServerUrl + params;
  }
}
